var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{attrs:{"value":_vm.show,"position":"bottom"},on:{"click-overlay":function($event){return _vm.$emit('hide')}}},[_c('van-picker',{attrs:{"show-toolbar":"","columns":_vm.cityColumns},on:{"cancel":function($event){return _vm.$emit('hide')},"confirm":_vm.onConfirm,"change":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }